export default __webpack_public_path__ + "static/media/electric-shower-gray.2f8d986a.svg";